// Panel Cover (2026-10-15). Cover dibakar worker ke 0,5 detik pertama video → otomatis jadi sampul
// bawaan TikTok & Reels + hook Shorts, tanpa upload thumbnail ke YouTube. Pilihan default = hasil
// editor thumbnail (bukan generate AI). Ditaruh DI ATAS Channel Tujuan: panel compliance TikTok
// harus tetap tepat sebelum tombol kirim.
import React, { useRef, useState } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';
import ShortsThumbEditor from './ShortsThumbEditor';

const API = process.env.REACT_APP_API_URL || 'https://api.sm-media.id';
const COVER_TEXT_MAX = 60;
const COVER_MAX_BYTES = 2 * 1024 * 1024;

const MODES = [
  { id: 'editor', label: '🎨 Dari editor' },
  { id: 'frame', label: '🎞️ Ambil dari frame' },
  { id: 'upload', label: '🖼️ Upload gambar' },
  { id: 'none', label: 'Tanpa cover' },
];

export const COVER_AWAL = { mode: 'editor', sec: 1, text: '', upload: null };

/** Field cover untuk API. Pilihan yang belum lengkap (belum ada thumbnail/gambar) → tanpa cover. */
export function coverPayload(c, shortsThumb) {
  if (c.mode === 'editor' && shortsThumb?.thumb_id) return { cover_mode: 'editor', thumbnail_id: shortsThumb.thumb_id };
  if (c.mode === 'upload' && c.upload?.cover_id) return { cover_mode: 'upload', cover_id: c.upload.cover_id };
  if (c.mode === 'frame') return { cover_mode: 'frame', cover_frame_sec: Number(c.sec) || 0, cover_text: (c.text || '').trim() };
  return { cover_mode: 'none' };
}

const hintStyle = { fontSize: 11, color: colors.textMuted, lineHeight: 1.5, marginTop: 6 };
const labelStyle = { fontSize: 12, fontWeight: 600, color: colors.textSecondary, marginBottom: 4, display: 'block' };

export default function CoverPanel({ value, onChange, shortsThumb, onShortsThumb, videoUrl, youtubeUrl, defaultTitle, hasYt, maxSec }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [dur, setDur] = useState(0);
  const videoRef = useRef(null);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const batas = Math.max(1, Math.floor(videoUrl ? (dur || maxSec || 60) : (maxSec || 44)));

  async function pickImage(f) {
    setErr('');
    if (!/^image\/(png|jpeg)$/.test(f.type)) return setErr('Format gambar harus PNG atau JPG');
    if (f.size > COVER_MAX_BYTES) return setErr('Ukuran gambar maksimal 2 MB');
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('cover', f);
      const r = await axios.post(`${API}/api/jobs/cover-upload`, fd);
      if (value.upload?.preview) URL.revokeObjectURL(value.upload.preview);
      set('upload', { cover_id: r.data.cover_id, preview: URL.createObjectURL(f), name: f.name });
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal mengunggah gambar cover');
    }
    setBusy(false);
  }

  function seek(v) {
    set('sec', v);
    if (videoRef.current) videoRef.current.currentTime = v;
  }

  const kosong = (value.mode === 'editor' && !shortsThumb) || (value.mode === 'upload' && !value.upload);

  return (
    <div style={{ marginBottom: 14, padding: '12px 14px', background: colors.bgCardMuted, borderRadius: 10, border: `1px solid ${colors.border}` }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, marginBottom: 4 }}>🖼️ Cover</div>
      <div style={{ fontSize: 11, color: colors.textSecondary, lineHeight: 1.5, marginBottom: 10 }}>
        Tampil 0,5 detik di awal video dan otomatis jadi sampul TikTok & Reels. Di YouTube Shorts, sampul tetap dipilih YouTube.
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
        {MODES.map(o => (
          <button key={o.id} type="button" onClick={() => { setErr(''); set('mode', o.id); }}
            style={{ padding: '6px 10px', fontSize: 12, fontWeight: 600, borderRadius: 8, cursor: 'pointer',
              border: `1px solid ${value.mode === o.id ? colors.accent : colors.border}`,
              background: value.mode === o.id ? colors.accentMuted : colors.bgCard,
              color: value.mode === o.id ? colors.accentText : colors.textPrimary }}>{o.label}</button>
        ))}
      </div>

      {value.mode === 'editor' && (
        <ShortsThumbEditor videoUrl={videoUrl} youtubeUrl={youtubeUrl} defaultTitle={defaultTitle} value={shortsThumb} onChange={onShortsThumb}
          hint={'Hasil editor ditanam jadi cover di awal video' + (hasYt ? ', dan juga dipasang sebagai thumbnail YouTube (channel harus sudah terverifikasi nomor HP).' : '.')} />
      )}

      {value.mode === 'frame' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div>
            <span style={labelStyle}>Frame di detik ke-{Number(value.sec || 0).toFixed(1)}</span>
            {videoUrl ? (
              <>
                <video ref={videoRef} src={videoUrl} muted playsInline preload="metadata"
                  onLoadedMetadata={e => { setDur(e.target.duration || 0); e.target.currentTime = Math.min(Number(value.sec) || 0, e.target.duration || 0); }}
                  style={{ width: '100%', maxHeight: 220, background: '#000', borderRadius: radius.md, display: 'block' }} />
                <input type="range" min={0} max={dur || batas} step={0.1} value={Math.min(Number(value.sec) || 0, dur || batas)}
                  onChange={e => seek(Number(e.target.value))} style={{ width: '100%', marginTop: 6, padding: 0, border: 'none', background: 'transparent', boxShadow: 'none' }} />
              </>
            ) : (
              <>
                <input type="number" min={0} max={batas} step={0.5} value={value.sec}
                  onChange={e => set('sec', Math.max(0, Math.min(batas, Number(e.target.value) || 0)))} style={{ width: 120 }} />
                <div style={hintStyle}>Dihitung dari awal potongan klip, bukan dari video aslinya (0–{batas} detik).</div>
              </>
            )}
          </div>
          <div>
            <span style={labelStyle}>Teks hook (opsional, {(value.text || '').length}/{COVER_TEXT_MAX})</span>
            <input type="text" maxLength={COVER_TEXT_MAX} placeholder="mis. WAJIB DENGAR SAMPAI HABIS" value={value.text}
              onChange={e => set('text', e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} />
            <div style={hintStyle}>Teks tebal di tengah dengan latar gelap supaya terbaca. Emoji tidak ditampilkan.</div>
          </div>
        </div>
      )}

      {value.mode === 'upload' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          {value.upload?.preview && (
            <img src={value.upload.preview} alt="Gambar cover" style={{ width: 54, height: 96, objectFit: 'cover', borderRadius: 6, border: `1px solid ${colors.border}` }} />
          )}
          <div style={{ flex: '1 1 180px', minWidth: 0 }}>
            <div style={{ fontSize: 12, color: colors.textPrimary, overflowWrap: 'anywhere' }}>{value.upload ? `✅ ${value.upload.name}` : 'PNG/JPG, maksimal 2 MB'}</div>
            <div style={hintStyle}>Dipotong otomatis mengikuti ukuran video. Paling pas gambar tegak 1080×1920.</div>
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <label className="btn btn-outline" style={{ display: 'inline-block', cursor: busy ? 'wait' : 'pointer', fontSize: 12 }}>
              {busy ? 'Mengunggah...' : value.upload ? 'Ganti' : '+ Pilih gambar'}
              <input type="file" accept="image/png,image/jpeg" style={{ display: 'none' }} disabled={busy}
                onChange={e => { const f = e.target.files[0]; e.target.value = ''; if (f) pickImage(f); }} />
            </label>
            {value.upload && <button type="button" className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => set('upload', null)}>Hapus</button>}
          </div>
        </div>
      )}

      {err && <div style={{ fontSize: 12, color: colors.danger, marginTop: 8 }}>{err}</div>}
      {kosong && <div style={{ ...hintStyle, color: colors.textSecondary }}>Belum ada {value.mode === 'editor' ? 'thumbnail' : 'gambar'} — video dikirim tanpa cover.</div>}
    </div>
  );
}
